export default "__VITE_ASSET__ItPpoheJ__"